import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-payment-terms-page',
	templateUrl: './payment-terms-page.component.html',
	styleUrls: ['./payment-terms-page.component.sass']
})
export class PaymentTermsPageComponent implements OnInit {

	constructor(private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('payment-terms')
	}

}
